import {  Directive, EventEmitter, Output, ViewContainerRef } from '@angular/core';
import { filter } from 'rxjs/operators';
import { FilterDatePeriodComponent } from 'src/components/filter components/filter-date-period/filter-date-period.component';
import { FilterNumberComponent } from 'src/components/filter components/filter-number/filter-number.component';
import { FilterSelectComponent } from 'src/components/filter components/filter-select/filter-select.component';
import { FilterTextComponent } from 'src/components/filter components/filter-text/filter-text.component';
import { FilterTimeComponent } from 'src/components/filter components/filter-time/filter-time.component';
import { Filter } from 'src/components/shared-components/class/general-classes/filter';
import { FiltersType } from 'src/components/shared-components/enum/enumFilters';

@Directive({
    selector: '[appFilterTablePlaceholder]',
    standalone: false
})
export class FilterTablePlaceholderDirective {
  //@Output() changedSelected = new EventEmitter<any>();

  constructor(
    private viewContainerRef: ViewContainerRef
  ) {
    viewContainerRef.constructor.name === "ViewContainerRef_"; // true
  }

  /**
   * Draw the filters
   */
  public drawFiltersComponent(
    filters: Filter[]
  ): void {
    const componentsHostViewRef = this.viewContainerRef;
    componentsHostViewRef.clear();

    let compFactory: any = null;

    filters.forEach(filter => {
      switch (filter.Kind) {
        case FiltersType.text:
          compFactory =
            this.viewContainerRef.createComponent(
              FilterTextComponent
            );
          if (compFactory != null) {
            const componentRef = componentsHostViewRef.createComponent(compFactory);
            const componentInstanceRef = componentRef.instance as FilterTextComponent;
            componentInstanceRef.Filter = filter;
          }
          break;
        case FiltersType.number:
          compFactory =
            this.viewContainerRef.createComponent(
              FilterNumberComponent
            );
          if (compFactory != null) {
            const componentRef = componentsHostViewRef.createComponent(compFactory);
            const componentInstanceRef = componentRef.instance as FilterNumberComponent;
            componentInstanceRef.Filter = filter;
          }
          break;
        case FiltersType.date:
          compFactory =
            this.viewContainerRef.createComponent(
              FilterDatePeriodComponent
            );
          if (compFactory != null) {
            const componentRef = componentsHostViewRef.createComponent(compFactory);
            const componentInstanceRef = componentRef.instance as FilterDatePeriodComponent;
            componentInstanceRef.Filter = filter;
          }
          break;
        case FiltersType.combo:
          compFactory =
            this.viewContainerRef.createComponent(
              FilterSelectComponent
            );
          if (compFactory != null) {
            const componentRef = componentsHostViewRef.createComponent(compFactory);
            const componentInstanceRef = componentRef.instance as FilterSelectComponent;
            componentInstanceRef.Filter = filter;
          }
          break;
        case FiltersType.time:
          compFactory =
            this.viewContainerRef.createComponent(
              FilterTimeComponent
            );
          if (compFactory != null) {
            const componentRef = componentsHostViewRef.createComponent(compFactory);
            const componentInstanceRef = componentRef.instance as FilterTimeComponent;
            componentInstanceRef.Filter = filter;
          }
        default:
          break;
      }
    });
  }
}
